// extracted by css-extract-rspack-plugin
export default {"EmptyStateFooter":"EmptyState-module__EmptyStateFooter___DiCbN"};